export function tryParseJSON(jsonString: unknown, returnOriginal = false) {
  try {
    if (typeof jsonString !== 'string') throw new Error('Not a string');
    return JSON.parse(jsonString);
  } catch {
    if (returnOriginal) return jsonString;
    return null;
  }
}
